import Vue from 'vue'
// import EventRootData from './EventRootData'
import EventUser from './EventUser'
import EventAct from './EventAct'
import EventZP from './EventZP'
import {ACT_NOT_INIT, ACT_RUNNING} from '../constant/act_stat'
import {isAndroid} from '../tools/mgtv/env'

const EventBus = new Vue({
    data: {
      act: {
        act_stat: ACT_NOT_INIT,
      },
      user: {
        uuid: null,
        vip_id: -1,
        nickname: "游客",
        avatar: "https://vipcdn.mgtv.com/upload/20180417/avatar.png",
        user_type: -1, // 0会员用户(有首冲，且是会员)　1新用户（无首冲）　2会员老用户（有首冲非会员）
        level: 0 //会员等级
      },
      device_info: {
        appVersion: '5.9.9_vipact',
        mac: '0000-0000-0000',
        did: '0000-0000-0000',
        osType: isAndroid() ? 'android' : 'ios'
      },
      zp_info: null,
      zp_rank: []
    },
    computed: {}
  })
;

EventBus.$useEvent = function (EventPlugin) {
  if (!EventPlugin) {
    throw new Error("事件插件不能为空");
  }
  if (!EventPlugin.install) {
    throw new Error("事件插件需要实现install方法");
  }
  EventPlugin.install(EventBus);
}

EventBus.$useEvent(EventAct);
EventBus.$useEvent(EventUser);
EventBus.$useEvent(EventZP);


window.$bus = EventBus;




// WEBPACK FOOTER //
// ./src/EventBus/index.js